import { AuthTokenResponse } from "@/api/register";
import { axiosInstance } from "@/axios/interceptors";
import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient();

class AuthService {
	private static instance: AuthService;
	private token: string | null = null;

	private constructor() {
		// Initialize from localStorage if available
		this.token = localStorage.getItem("access_token");
		if (this.token) {
			this.addTokenToHeader();
		}
	}

	public static getInstance(): AuthService {
		if (!AuthService.instance) {
			AuthService.instance = new AuthService();
		}
		return AuthService.instance;
	}

	public addTokenToHeader(): void {
		axiosInstance.defaults.headers.common.Authorization = `Bearer ${this.token}`;
	}

	public getToken(): string | null {
		return this.token;
	}

	public setToken(tokenData: Pick<AuthTokenResponse, "access_token">): void {
		this.token = tokenData.access_token;
		localStorage.setItem("access_token", tokenData.access_token);
		this.addTokenToHeader();
	}

	public clearToken(): void {
		this.token = null;
		localStorage.removeItem("access_token");
		axiosInstance.defaults.headers.common.Authorization = "";
		queryClient.clear();
	}

	public isAuthenticated(): boolean {
		return !!this.getToken();
	}
}

export const authService = AuthService.getInstance();
